const es = {
  nav: {
    home: "home",
    ourStory: "our story",
    menus: "menus",
    specialMenus: "menús especiales",
    gallery: "gallery",
    locations: "locations",
    contact: "contact",
    privateEvents: "eventos privados",
    comingSoon: "próximamente",
  },
  home: {
    hero: {
      subtitle: "Auténtica Cocina del Norte de Italia y Francia",
      description: "Desde Chicago hasta Guatemala, tres generaciones de excelencia culinaria. Pasta fresca artesanal, los mejores vinos y una experiencia gastronómica única.",
      viewMenus: "Ver Menús",
    },
    legacy: {
      title: "Un Legado de Chicago, Ahora Global",
      p1: 'Desde 1985, Carlos & Carlos ha sido un referente de la alta cocina franco-italiana en Chicago. Fundado por los hermanos Montiel, nuestro restaurante de manteles blancos en Arlington Heights rápidamente se ganó un lugar entre la élite culinaria, atrayendo a celebridades como Tom Cruise, Robert De Niro y Paul Newman.',
      p2: 'Hoy, con tres locaciones en dos países, seguimos honrando nuestra tradición de pasta fresca artesanal, los mejores cortes de carne y una carta de vinos incomparable.',
      btn: "Nuestra Historia",
    },
    counters: {
      years: "Años de Tradición",
      yearsDesc: "Sirviendo excelencia desde 1985 en Chicago",
      locations: "Locaciones",
      locationsDesc: "Arlington Heights · Wilmette · Antigua",
      dishes: "Platos Signature",
      dishesDesc: "Un menú curado de clásicos del norte de Italia y Francia",
    },
    infoCards: {
      pasta: "Pasta Artesanal",
      pastaDesc: "Pasta fresca hecha en casa diariamente, siguiendo recetas tradicionales italianas",
      ingredients: "Ingredientes Premium",
      ingredientsDesc: "Los mejores ingredientes importados de Italia y productos locales frescos",
      wine: "Carta de Vinos",
      wineDesc: "Extensa selección de vinos italianos y del mundo, cuidadosamente seleccionados",
      ambiance: "Ambiente Elegante",
      ambianceDesc: "Servicio impecable en un ambiente sofisticado de manteles blancos",
    },
    locations: {
      title: "Nuestras Locaciones",
      subtitle: "Tres locaciones, dos países, una tradición.",
      antigua: "Antigua Guatemala",
      antiguaDesc: "Próximamente",
      comingSoonNote: "Próximamente en una nueva ubicación dentro de Antigua Guatemala.",
      wilmette: "Wilmette, IL",
      wilmetteDesc: "615 Green Bay Road, Wilmette · 847-920-5058",
      arlington: "Arlington Heights, IL",
      arlingtonDesc: "27 West Campbell Ave, Arlington Hts · 847-259-2600",
      viewDetails: "View Details",
    },
    reserve: {
      title: "Reserve su Mesa",
      description: "Nos sentiremos honrados de brindarle una experiencia gastronómica única, excelente atención, en adición al ambiente, confort y locación.",
    },
    giftCards: {
      title: "Gift Cards Disponibles",
      description: "Regala una experiencia gastronómica inolvidable. Perfecto para cualquier ocasión.",
      action: "Más Información",
    },
  },
  about: {
    hero: {
      title: "Our Story",
      subtitle: "Since 1985 — Un legado de excelencia italiana.",
    },
    title: "Chicago 1985",
    p1: 'A principios de 1985, CARLOS MONTIEL y su hermano EDDY MONTIEL, abrieron un pequeño restaurante que eventualmente cambiaría de alguna manera la forma de comer en Chicago. Se aventuraron en un lugar que nadie se atrevería a abrir, dejando solo un restaurante de manteles blancos del norte de Italia.',
    p2: 'Haciendo pasta fresca frente a los comensales y con servicio de meseros de etiqueta, Carlos & Carlos comenzó una maravillosa trayectoria gastronómica. Platos emblemáticos como el Black Pasta con camarones y vieiras en salsa de crema de champagne, el Veal Carlos con hongos porcini y salsa de crema, y el salmón fresco escalfado con salsa de langosta, le dieron a Carlos & Carlos un lugar entre los restaurantes de élite de Chicago.',
    p3: 'Este pequeño y acogedor restaurante se convirtió en un imán para la alta sociedad de Chicago, atrayendo a personalidades como Tom Cruise, Robert De Niro, Paul Newman, Julia Roberts y el diseñador Oscar de la Renta, entre muchos otros.',
    cards: {
      established: "Est. 1985",
      establishedDesc: "Fundado en Chicago por los hermanos Montiel con una visión audaz",
      cuisine: "Cocina Franco-Italiana",
      cuisineDesc: "Fusión única de la cocina del norte de Italia y Francia",
      recognition: "Reconocimiento Internacional",
      recognitionDesc: "Aclamado por críticos y celebridades de todo el mundo",
      locations: "3 Locaciones",
        locationsDesc: "Arlington Heights, Wilmette y Antigua Guatemala",
    },
    milestones: {
      title: "Nuestra Historia",
      chicago: "Chicago",
      chicagoDesc: "Los hermanos Montiel abren las puertas del primer Carlos & Carlos en Chicago, en el corazón de Arlington Heights. Con una fusión única de cocina del norte de Italia y francesa, pronto recibiría a grandes íconos como Tom Cruise, Robert De Niro, Paul Newman y Julia Roberts.",
      guatemala: "Guatemala",
      guatemalaDesc: "Tras haber conseguido el éxito internacional, Carlos & Carlos se expande y abre sus puertas en el Aeropuerto Internacional La Aurora en la Ciudad de Guatemala, ofreciendo platillos de alta calidad elaborados con pasta artesanal.",
      antigua: "Antigua Guatemala",
      antiguaDesc: "Carlos & Carlos hace su debut en Antigua Guatemala el 12 de enero de 2023, ofreciendo una variedad de platillos de alta calidad, una extensa selección de vinos y ampliando un legado de reconocimiento internacional.",
    },
  },
  contact: {
    hero: {
      title: "Contact Us",
      subtitle: "Nos encantaría saber de usted.",
    },
    title: "Get In Touch",
    description: "Nos sentiremos honrados que seleccione Carlos & Carlos en su próxima visita. Estaremos gustosos de brindarle una experiencia gastronómica única.",
    reservations: "Reservaciones",
    form: {
      select: "Seleccione un restaurante",
      antigua: "Antigua Guatemala",
      wilmette: "Wilmette, IL",
      arlington: "Arlington Heights, IL",
      name: "Nombre Completo",
      namePlaceholder: "Su nombre completo",
      email: "Correo Electrónico",
      emailPlaceholder: "su@email.com",
      subject: "Asunto",
      subjectPlaceholder: "¿Cómo podemos ayudarle?",
      message: "Su Mensaje",
      messagePlaceholder: "Cuéntenos más sobre su consulta...",
      send: "Enviar Mensaje",
    },
  },
  menus: {
    hero: {
      title: "Nuestro Menú",
      subtitle: "Cocina del Norte de Italia y Francia. Pasta artesanal desde 1985.",
    },
    antiguaClosed: "Antigua Guatemala",
    antiguaClosedDesc: "Estamos emocionados de anunciar que pronto abriremos nuestras puertas en una nueva ubicación dentro de Antigua Guatemala. ¡Gracias por su paciencia y apoyo! Estén atentos para más detalles.",
  },
  specialMenus: {
    hero: {
      title: "Menús Especiales",
      subtitle: "Próximamente nuevos menús especiales.",
    },
    comingSoon: "¡Próximamente!",
    comingSoonDesc: "Estamos trabajando en nuevos menús especiales para usted. Antigua Guatemala se mudará a una nueva ubicación dentro de la ciudad. ¡Espérenos pronto!",
  },
  gallery: {
    hero: {
      title: "Galería",
      subtitle: "Explore nuestros restaurantes.",
    },
  },
  locations: {
    hours: "HORARIO",
    visitOther: "Visita Nuestras Otras Locaciones",
    antiguaClosed: "Antigua Guatemala — Temporalmente Cerrado",
    antiguaClosedDesc: "Próximamente en una nueva ubicación dentro de Antigua Guatemala.",
  },
  privateEvents: {
    hero: {
      title: "Eventos Privados",
      subtitle: "Celebre con nosotros — una experiencia gastronómica exclusiva.",
    },
    title: "Coordine su Evento Especial",
    description: "En Carlos & Carlos, estamos encantados de recibirlo para coordinar eventos privados en horarios de medio día y cena. Ya sea una comida corporativa, una celebración familiar o una reunión íntima, nuestro equipo se asegurará de que cada detalle sea perfecto.",
    details: "Contamos con espacios versátiles y un menú personalizable para adaptarnos a sus necesidades. Nuestro servicio de primer nivel y nuestra cocina excepcional harán de su evento una experiencia inolvidable.",
    call: "Llámenos para reservar o solicitar más información.",
    moreInfo: "Más Información",
    phones: "Reservaciones",
  },
  footer: {
    locations: "locations",
    company: "company",
    ourstory: "our story",
    menus: "menus",
    gallery: "gallery",
    contact: "contact",
    AntiguaGuatemala: "Antigua Guatemala",
    WilmetteIL: "Wilmette, IL",
    ArlingtonHeightsIL: "Arlington Heights, IL",
  },
};

export default es;
